import { STATUSPAGE, MainButton, PageWrapper } from '@repo/ui';
import { EntityType } from 'domain/value-objects/entities-type';
import { getEntityTypeLabel } from 'domain/value-objects/entity-type';
import imgFileDocx from 'presentation/app/assets/images/file-docx.png';
import { useEffect, useRef, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { Form, Card, Button, CardBody, CardFooter } from 'reactstrap';
import * as Yup from 'yup';

import { RegisterDataForm } from '../components/form/register-data-form';
import { SettingForm } from '../components/form/setting-form';
import { useEntities } from '../hooks/useEntities';

export const CreateEntityForm = () => {
  // State
  const [fileSelected, setFileSelected] = useState<any>(null);
  const [modalDeleteState, setModalDeleteState] = useState<boolean>(false);

  // Hooks
  const { entityId } = useParams();

  const navigate = useNavigate();
  const marginYButton = 'my-1';

  const {
    setDeleteTce,
    requestSearchByCnpj,
    requestEntitiesDelete,
    requestEntitiesGetById,
    requestGetAddressViaZipCode,
    setCitiesForSelectOptionsData,
    requestGetAllInsuranceCompanies,
    requestGetAllCitiesForSelectOptions,
    setInternshipLocationPhotoImagePreviewSrc,
    validation,
    searchByCnpjData,
    statusEditEntities,
    loadingSearchByCnpj,
    statusCreateEntities,
    responseEntitiesById,
    listInsuranceCompanies,
    hasChangedAddressFields,
    citiesForSelectOptionsData,
    statusDeleteEntities,
  } = useEntities();

  const options = [
    {
      label: getEntityTypeLabel(EntityType.Institution),
      value: EntityType.Institution,
    },
    {
      label: getEntityTypeLabel(EntityType.PublicAgency),
      value: EntityType.PublicAgency,
    },
    {
      label: getEntityTypeLabel(EntityType.Company),
      value: EntityType.Company,
    },
  ];

  const zipCodeSchema = Yup.string()
    .zipCodeType('CEP inválido')
    .required('Campo é obrigatório');

  const handleDeleteFile = (e) => {
    setDeleteTce(true);
    e.preventDefault();
    validation.setFieldValue('tce.rescissionTermModel', null);
    fileInputRef.current.value = '';
  };

  const fileInputRef = useRef<HTMLInputElement>(null);

  useEffect(() => {
    if (responseEntitiesById) {
      setInternshipLocationPhotoImagePreviewSrc(responseEntitiesById?.photo);
    }
  }, [responseEntitiesById]);

  useEffect(() => {
    requestGetAllInsuranceCompanies();
    if (entityId) {
      requestEntitiesGetById({ id: entityId });
    }
  }, []);

  return (
    <PageWrapper title="Cadastro Organização">
      <div className="d-flex justify-content-between align-items-center mb-4">
        <div>
          <h4 className="fw-bold">Criar Organização</h4>
        </div>
      </div>

      <Form
        autoComplete="off"
        onSubmit={(e) => {
          e.preventDefault();
          validation.handleSubmit();
          return false;
        }}
      >
        <Card className="mb-1">
          <CardBody>
            <RegisterDataForm
              requestGetAllCitiesForSelectOptions={
                requestGetAllCitiesForSelectOptions
              }
              options={options}
              entityId={entityId}
              validation={validation}
              zipCodeSchema={zipCodeSchema}
              marginYButton={marginYButton}
              modalDeleteState={modalDeleteState}
              searchByCnpjData={searchByCnpjData}
              requestSearchByCnpj={requestSearchByCnpj}
              loadingSearchByCnpj={loadingSearchByCnpj}
              setModalDeleteState={setModalDeleteState}
              requestEntitiesDelete={requestEntitiesDelete}
              hasChangedAddressFields={hasChangedAddressFields}
              citiesForSelectOptionsData={citiesForSelectOptionsData}
              requestGetAddressViaZipCode={requestGetAddressViaZipCode}
              setCitiesForSelectOptionsData={setCitiesForSelectOptionsData}
              loadingArchive={statusDeleteEntities === STATUSPAGE.LOADING}
            />
            <SettingForm
              validation={validation}
              imgFileDocx={imgFileDocx}
              fileInputRef={fileInputRef}
              fileSelected={fileSelected}
              setDeleteTce={setDeleteTce}
              marginYButton={marginYButton}
              setFileSelected={setFileSelected}
              handleDeleteFile={handleDeleteFile}
              listInsuranceCompanies={listInsuranceCompanies}
            />
          </CardBody>

          <CardFooter>
            <div
              style={{
                justifyContent: 'end',
                alignItems: 'center',
                display: 'flex',
              }}
            >
              <div className="d-flex">
                <Button
                  color="link"
                  className="btn-link text-decoration-underline"
                  onClick={() => navigate('/organizacoes')}
                >
                  Cancelar
                </Button>
                <MainButton
                  type="submit"
                  isDisabled={
                    statusCreateEntities === STATUSPAGE.LOADING ||
                    statusEditEntities === STATUSPAGE.LOADING
                  }
                  isLoading={
                    !!statusCreateEntities ||
                    statusEditEntities === STATUSPAGE.LOADING
                  }
                >
                  Salvar
                </MainButton>
              </div>
            </div>
          </CardFooter>
        </Card>
      </Form>
    </PageWrapper>
  );
};
